import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface T3EmptyStateProps {
  title: string;
  hint?: string;
  action?: ReactNode;
}

/** Centered empty state: title, muted hint, optional call-to-action. */
export function T3EmptyState({ title, hint, action }: T3EmptyStateProps) {
  return (
    <Box sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h4" component="p" gutterBottom>
        {title}
      </Typography>
      {hint ? (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {hint}
        </Typography>
      ) : null}
      {action ? <Box>{action}</Box> : null}
    </Box>
  );
}
